export default {
    repairPolygon: "Une erreur s'est produite en tentant de réparer le polygone...",
    passwordChanged: 'Votre mot de passe a changé',
    reset: 'Un lien de réinitialisation a été envoyé à votre adresse e-mail',
    activationLink: "Un lien d'activation a été envoyé à votre email",
    detailsChanged: 'Vos coordonnées ont changé',

    artefactInfo: 'Aucune modification à enregistrer',
    artefactSuccess: 'Artefact sauvegardé',
    artefactError: 'La sauvegarde de l\'artefact a echoué',
    artefactsAutoModeError: 'Le mode automatique n\'est pas possible lorsque plus d\'une lettre est sélectionnée',

    editionSuccess: 'Edition renommée',
    editionError: 'Le renommage de l\'édition a échoué',

    editionDeleteSuccess: 'edition supprimée',
    editionDeleteError: 'La suppression de l\'édition a échoué',

    invitationSent: 'Invitation envoyée à {email}',
    permissionsUpdated: 'Autorisations de {email} mises à jour',

    NoChangesDetected: 'Aucun changement détecté',
    imagedObjectFailed: 'La sauvegarde de l\'Imaged Object à echoué',
    imagedObjectSaved: 'Imaged Object sauvegardé',

    artefactCreated: 'Artefact créé',
    artefactCreatedFailed: 'La creation de l\'artefact à echoué',

    artefactRenamed: 'Artefact renommé',
    artefactRenameFailed: 'Le renommage de l\'artefact à échoué',

    artefactDeleted: 'Artefact supprimé',
    deleteArtefactFailed: "Échec de la suppression de l'artefact",
    artefactCantOverlap: "L'artefact ne peut pas superposer d'autres artefacts"

    // TODO: Translate attributeDeletedBySomeoneElse to French
};

